import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Col, Container, FormGroup, Label, Row, Form, Button, Spinner } from 'reactstrap'
import useAddOrg from './useAddOrg'
import useEditOrg from 'pages/Dboard/useEditOrg'
import { useQueryClient } from '@tanstack/react-query'
import { fetchInitDataFn } from './useIniDataFromDb'

const OrgAddEditForm = ({isEditMode, orgData, onClose}) => {
    const queryClient= useQueryClient();
    // add hook
    const{isPending, isSuccess, isError, createOrg} = useAddOrg();
    // edit org
    const{isEditing, isEdited, updateOrg} = useEditOrg();

    // state for getting states
    const[states,setStates]=useState([])

    // getting data from local storage
    useEffect(()=>{
        const cachedData = localStorage.getItem('appInitData')

        if (cachedData){
            const parsedData = JSON.parse(cachedData);
            setStates(parsedData.us_state || [])
        }
        
    },[])

    // hook form
    const{register, handleSubmit, formState:{errors},reset, watch} = useForm({
        defaultValues:{
            name:"",
            addr_line1:"",
            addr_line2:"",
            city:"",
            state_code:"",
            zip_code:""
        },
        criteriaMode:"all",
        mode:"onChange"
    })

    // onEditing, populate all the existing data
    useEffect(()=>{
        if(isEditMode && orgData){
            console.log("Org data for editing:",orgData)
           const formValues = {
                    name: orgData.name,
                    addr_line1: orgData.address?.addr_line1 || '',
                    addr_line2: orgData.address?.addr_line2 || '',
                    city: orgData.address?.city || '',
                    state_code: orgData.address?.state_code || '',
                    zip_code: orgData.address?.zip_code || ''
                    };

            reset(formValues);
        }
        else{
            reset();
        }
    },[isEditMode, orgData, reset,states])

    const onSubmit=async(data)=>{
        const payload={
            name: data.name,
            address:{
                addr_line1: data.addr_line1,
                addr_line2: data.addr_line2,
                city: data.city,
                state_code: data.state_code,
                zip_code: data.zip_code
            },

             ...(isEditMode && { org_id: orgData.org_id })
            
        }

        if(isEditMode){
            console.log("Editing Done",payload)
            updateOrg(payload,{
                onSuccess:()=>{
                    onClose();
                }
            })
        }else{
            console.log("adding Done",payload)
            createOrg(payload,{
                onSuccess: async ()=>{
                    onClose();
                     await queryClient.prefetchQuery({
                        queryKey: ['initData'],
                        queryFn: fetchInitDataFn,
                    });
                }
            })
        }
    }

  return (
    <Container fluid>
        <Row>
            <Col>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='name' className='form-label'>Name of Organization</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='name'
                                    name='name'
                                    placeholder='Name of Organization'
                                    {...register("name",{required:"Name of Organization is required",
                                        minLength:{value:1,message:"Org Name must have atleast 1 characters"},
                                        pattern:{value: /^(?! )[A-Za-z0-9]+(?: [A-Za-z0-9]+)*(?<! )$/ ,message:"Organization name must consist of letters and numbers only, with a single space permitted between words. Leading or trailing spaces and special characters are not allowed."}
                                    })}
                                />
                                {errors.name && <span className="text-danger">{errors.name.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col>
                             <FormGroup>
                                <Label htmlFor='addr_line1' className='form-label'>Address Line 1</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='addr_line1'
                                    name='addr_line1'
                                    placeholder='Address Line 1'
                                    {...register("addr_line1",{required:"Address is required",
                                        pattern:{value:/^(?!\s).*/, message:"Address must not start with a space."}
                                    })}
                                />
                                {errors.addr_line1 && <span className="text-danger">{errors.addr_line1.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='addr_line2' className='form-label'>Address Line 2</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='addr_line2'
                                    name='addr_line2'
                                    placeholder='Address Line 2'
                                    {...register("addr_line2",{pattern:{value:/^(?!\s).*/, message:"Address must not start with a space."}})}
                                />
                                {errors.addr_line2 && <span className="text-danger">{errors.addr_line2.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col>
                            {/* <FormGroup>
                                <Label htmlFor='state_code' className='form-label'>State Code</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='state_code'
                                    name='state_code'
                                    placeholder='State Code'
                                    {...register("state_code",{required:"State Code is Required",
                                        minLength:{value:2, message:"State Code contains 2 values"},
                                        pattern:{value: /^(?!\s)[A-Z]{2}(?<!\s)$/, message:"Please enter a valid two-letter U.S. state code in uppercase (e.g., CA). Only alphabetic characters are allowed; spaces, numbers, and special characters are not permitted."}
                                    })}
                                />
                                {errors.state_code && <span className="text-danger">{errors.state_code.message}</span>}
                            </FormGroup> */}

                            <FormGroup>
                                <Label htmlFor='state_code' className='form-label'>State</Label>
                                <select
                                    className='form-select border-primary-subtle'
                                    id='state_code'
                                    name='state_code'
                                    defaultValue=""
                                    {...register("state_code",{required:"State is required"})}
                                >
                                <option value="" disabled>Select State</option>
                                {states.map((state,index)=>(
                                    <option key={index} value={state.state_code}>{state.state_code}</option>
                                ))}
                                </select>

                                {errors.state_code && <span className="text-danger">{errors.state_code.message}</span>}
                        
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
        
                        <Col>
                            <FormGroup>
                                <Label htmlFor='city' className='form-label'>City</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='city'
                                    name='city'
                                    placeholder='City'
                                    {...register("city",{required:"City is Required",
                                        minLength:{value:2, message:"City needs atleast 2 characters long"},
                                        pattern:{value: /^(?! )[A-Za-zÀ-ÿ]+(?:[- ][A-Za-zÀ-ÿ]+)*(?<! )$/, message:"City name must contain only letters, single spaces or hyphens. Leading/trailing spaces, numbers, and special characters are not allowed."}
                                    })}
                                />
                                {errors.city && <span className="text-danger">{errors.city.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='zip_code' className='form-label'>Zip Code</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='zip_code'
                                    name='zip_code'
                                    placeholder='Zip COde'
                                    {...register("zip_code",{required:"Zip Code is Required",
                                        minLength:{value:5, message:"Zip must have atleast 5 numbers."},
                                        maxLength:{value:10, message:"Zip must have maximum 10 numbers."},
                                        pattern:{value:/^(?!\s)[0-9]{5}(?:-[0-9]{4})?(?<!\s)$/, message:"Please enter a valid 5-digit ZIP code or ZIP+4 format. Only digits are allowed, with an optional hyphen followed by 4 digits."}
                                    })}
                                />
                                {errors.zip_code && <span className="text-danger">{errors.zip_code.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col></Col>
                        <Col></Col>
                    </Row>

                    <div style={{display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center"}}>
                        <Button type='submit' className="btn py-2" style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }}
                            disabled={isPending || isEditing}
                        >
                            {isPending || isEditing ? <Spinner size="sm"/> : "Submit"}
                        </Button>
                    </div>
                </Form>
            </Col>
        </Row>
    </Container>
  )
}

export default OrgAddEditForm